import React from 'react'
import { Route } from 'react-router-dom'
import ResourcesConfigurations from '../../../../components/ResourcesView'

const ResourcesConfigurationsRoutes = ({ match }) => (
  <div>
    <Route path={match.path} component={ResourcesConfigurations} />
  </div>
)

export default ResourcesConfigurationsRoutes